<template>
  <div class="export-file-wrapper">
    <div class="export-file-card">
      <h2>{{ titleTxt }}</h2>

      <AnimationItem class="download-animation" :class="[status]" v-if="status === 'success'" :key="status" :animation="{ animationData: paymentSuccessAnimation.default, loop: false }"/>
      <AnimationItem class="download-animation" :class="[status]" v-if="status === 'error' || status === 'gone'" :key="status" :animation="{ animationData: paymentErrorAnimation.default, loop: false }"/>
      <AnimationItem class="download-animation" :class="[status]" v-if="status === 'unauthorized'" :key="status" :animation="{ animationData: paymentErrorAnimation.default, loop: false }"/>
      <AnimationItem class="download-animation" :class="[status]" v-if="status === 'pending'" :key="status" :animation="{ animationData: paymentPendingAnimation.default, loop: false }"/>

      <div v-if="status==='success'" class="gk-tip gk-tip--blue text-center">
        <p>{{ $gettext('Your download might be blocked by a pop-up warning in the top right of the URL bar. Please click on the pop-up warning to allow the download from getgekko.com to continue. (This warning can differ per browser)') }}</p>
      </div>
      <div v-if="status === 'unauthorized'" class="text-center">
        <p>{{ $gettext('It appears you are not signed in. Sign in to download this file.') }}</p>
      </div>
      <div v-if="status === 'gone'">
        <p>{{ $gettext("This file has expired or doesn't exist.") }}</p>
      </div>
      <div class="retry-box pt-3">
        <div v-if="status !== 'unauthorized' && status !== 'gone'"></div>
        <span>{{ $gettext('Important! This download file will only be available for three days from the time it is created. Then it will be expired and you can no longer use this file. To download your data after the expiration date, you must generate a new download file.') }}</span>
        <span>{{ $gettext('If your download doesn\'t start immediately, try to') }}</span>&nbsp;<span class="text-blue cursor-pointer btn-link" @click="attemptDownload">{{ $gettext('download manually') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import * as paymentSuccessAnimation from '@/css/animations/payment-complete.json'
import * as paymentErrorAnimation from '@/css/animations/payment-error.json'
import * as paymentPendingAnimation from '@/css/animations/payment-pending.json'
import AnimationItem from '@/components/dashboard/ui/AnimationItem.vue'

import GekkoButton from '@/components/GekkoButton'

import TemporaryFileService from '@/store/services/temporaryfile.service.js'

export default {
  name: 'DownloadFile',
  components: {
    AnimationItem,
    GekkoButton
  },
  data() {
    return {
      status: null,
      filetype: null,
      uuid: null,
      paymentSuccessAnimation: paymentSuccessAnimation,
      paymentErrorAnimation: paymentErrorAnimation,
      paymentPendingAnimation: paymentPendingAnimation,
      requestedFileUrl: null,
    }
  },
  computed: {
    titleTxt() {
      switch (this.status) {
        case 'pending':
          return this.$gettext('Your download will begin shortly.')

        case 'success':
          return this.$gettext('Your download is ready!')

        case 'error':
          return this.$gettext('Oops! There was an error.')

        case 'unauthorized':
          return this.$gettext('Unauthorized.')

        case 'gone':
          return this.$gettext('File not found.')

        default:
          throw "Unknown status"
      }
    }
  },
  created() {
    this.filetype = this.$route.params['filetype'];
    this.uuid = this.$route.params['uuid'];
    this.attemptDownload();
  },
  methods: {
    attemptDownload() {
      this.status = 'pending'
      if (this.filetype === "export-file") {
        TemporaryFileService.download(this.uuid).then((response) => {
          this.status = 'success'
          this.requestedFileUrl = response.data
          // window.open(this.requestedFileUrl, '_blank')
          const a = document.createElement('a')
          a.href = this.requestedFileUrl
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(this.requestedFileUrl)
        }).catch((error) => {
          const code = error.data ? error.data.error : null
          if (error.status === 404 || error.status === 410) {
            this.status = 'gone'
          } else if (error.status === 401 || (error.status === 400 && code === 'invalid_grant')) {
            this.status = 'unauthorized'
            this.$router.push({
              name: 'login',
              query: {
                redirect: this.$route.fullPath
              }
            })
          } else {
            this.status = 'error'
          }
        }).finally(() => {
          const alertTitle = this.$gettext('Download')
          if (this.status === 'error') {
            const alertMsg = this.$gettext("Could not find file to download.")
            const alertVariant = 'danger'
            this.$store.commit('setAlert', {
              title: alertTitle,
              text: alertMsg,
              variant: alertVariant,
              duration: 4
            })
          } else if (this.status === 'gone') {
            const alertMsg = this.$gettext("The download file has expired.")
            const alertVariant = 'warning'
            this.$store.commit('setAlert', {
              title: alertTitle,
              text: alertMsg,
              variant: alertVariant,
              duration: 4
            })
          }
        })
      }
    },
  }
}
</script>

<style lang="scss">
.export-file-card {
  .download-animation {
    width: 80px !important;

    &.pending {
      svg {
        padding: 0.5rem;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.export-file-wrapper {
  padding-top: 3rem;
  text-align: center;

  .export-file-card {
    background-color: white;
    border: 1px solid $colorBorderDash;
    border-radius: $radiusLg;
    padding: 2rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 450px;

    .retry-box {
      font-size: 1rem;
    }
  }
}
</style>